"use strict";
// This map will only include payment methods which are to be added for a particular region only
// and not for all regions with a particular currency. If a payment method is to be switched on for
// all regions for the currency (i.e. currencywide) add the payment method in currencies.ts instead
Object.defineProperty(exports, "__esModule", { value: true });
exports.paymentMethodsByRegion = void 0;
exports.paymentMethodsByRegion = {
    luxuryescapes: {
        DE: {
            paymentMethods: [
                "stripe_payment_element_card",
                "stripe_payment_element_giropay", // restrict by region as Euro is used in many countries
            ],
        },
    },
};
